import React from "react";
import { Filter, useTranslate, } from 'react-admin';

import TextInputEx from "../../../components/_extensions/react-admin/input/TextInputEx";
import { SelectEnumInput } from "components/inputs/SelectEnumInput";
import { NotificationSubscriptionEventType } from "entities/NotificationSubscriptionEventType";
import { ThirdPartyInput } from "components/inputs/ThirdPartyInput";
import { DateTimeInput } from "components/inputs";


export const ClientNotificationSubscriptionFilter = (props) => {
	const translate = useTranslate();

	return (
		<Filter {...props}>
			<ThirdPartyInput source="oauth2_client_id" />
			<TextInputEx source="callback_url" />
			<SelectEnumInput source="event_type" 
				enumObj={NotificationSubscriptionEventType} enumName="notification_subscription" resettable />
			<DateTimeInput source="created_at:gte" label={translate("osfc.filters.created_at.from")} withLocalTimeZone />
			<DateTimeInput source="created_at:lte" label={translate("osfc.filters.created_at.to")} withLocalTimeZone />
		</Filter>
	);
};
